




















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import SessionModule from '~/store/session';
import EnrollmentModule from '~/store/enrollment';
// import InformationModal from '~/components/site/informationModal.vue';

@Component<Header>({
    components: {
        // InformationModal,
    },
    icons: {
        faInfoCircle,
    },
})
export default class Header extends Vue {
    @Resolve
    session!: SessionModule;

    @Resolve
    public enrollment!: EnrollmentModule;

    // isShowInformationDialogue = false;

    // toggleInfoDialogue() {
    //     this.isShowInformationDialogue = !this.isShowInformationDialogue;
    // }

    handleHomeClick() {
        this.enrollment.clearStore()
       // this.$router.push({ path: '/' });
    }
}
